import React from 'react'
import { Link } from 'react-router-dom';
function ServiceEight() {
    return (
        <div>
            {/* rts service post area  Start*/}
            <div className="rts-service-area eight rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-title-area service text-center">
                                <p className="pre-title">Our Services</p>
                                <h2 className="title">Our Services</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid service-main plr--120-service mt--50 plr_md--0 pl_sm--0 pr_sm--0">
                    <div className="background-service row">
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner one">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/service-logo11.svg"
                                        alt="aqc_service"
                                    />
                                </div>
                                <div className="service-details">
                                    <Link to={'/services'}>
                                        <h5 className="title">HSE Services</h5>
                                    </Link>
                                    <p className="disc">
                                    Comprehensive inspections and audits to ensure equipment, structures, and processes meet industry standards.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/services'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner two">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/service-logo4.svg"
                                        alt="aqc_service"
                                    />
                                </div>
                                <div className="service-details">
                                    <Link to={'/services'}>
                                        <h5 className="title">Third-Party Inspection Services</h5>
                                    </Link>
                                    <p className="disc">
                                    Expert guidance on health, safety, and environmental management through policies, risk assessments, and audits.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/services'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner three">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/service-logo5.svg"
                                        alt="aqc_service"
                                    />
                                </div>
                                <div className="service-details">
                                    <Link to={'/services'}>
                                        <h5 className="title">Calibration Testing & Certification Services</h5>
                                    </Link>
                                    <p className="disc">
                                    Support for ISO certification, business process optimization, and compliance management.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/services'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner four">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/service-logo6.svg"
                                        alt="aqc_service"
                                    />
                                </div>
                                <div className="service-details">
                                    <Link to={'/services'}>
                                        <h5 className="title">Calibration Testing & Certification</h5>
                                    </Link>
                                    <p className="disc">
                                    Accurate calibration and certification services for pressure, temperature, electrical, and mechanical equipment.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/services'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div> */}
                        {/* end single Services */}
                        {/* start single Service */}
                        {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner five">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/service-logo22.svg"
                                        alt="aqc_service"
                                    />
                                </div>
                                <div className="service-details">
                                    <Link to={'/services'}>
                                        <h5 className="title">Incident Investigation & Reporting</h5>
                                    </Link>
                                    <p className="disc">
                                    Independent analysis, reporting, and prevention strategies for workplace accidents.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/services'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div> */}
                        {/* end single Services */}
                        {/* start single Service */}
                        {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner six">
                                <div className="thumbnail">
                                    <img
                                        src="assets/images/service/icon/service-logo33.svg"
                                        alt="aqc_service"
                                    />
                                </div>
                                <div className="service-details">
                                    <Link to={'/services'}>
                                        <h5 className="title">Behavioral Safety & Culture</h5>
                                    </Link>
                                    <p className="disc">
                                    Evaluating and enhancing safety behavior and awareness in organizations.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/services'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        Read More
                                    </Link>
                                </div>
                            </div>
                        </div> */}
                        {/* end single Services */}
                    </div>
                </div>
            </div>
            {/* rts service post area ENd */}
        </div>
    )
}

export default ServiceEight